var generic = generic || {};
var site = site || {};
var Mustache = Mustache || {};

(function ($) {
  var shades = JSON.parse(localStorage.getItem('dw_foundation_sampling_shades')) || {};

  if (!shades) {
    shades = { update_shade: 1 };
  }
  var update_shade = shades.update_shade ? shades.update_shade : 1;
  var trnsItems = {};

  $('.sppmg__addToCart').removeClass('js-add-to-cart').addClass('js-dw-select-shade');
  Drupal.behaviors.dw_foundation_sampling_select_shades_v1 = {
    attach: function (context) {
      var container = $('.js-dw__foundation__sampling__shades-selected', context).html();
      var self = this;
      var shade_1 = self.getMapKeyValue(shades['shade_1'], 'sku-base-id');
      var shade_2 = self.getMapKeyValue(shades['shade_2'], 'sku-base-id');

      shade_1 && self.setRemoveText(context, shade_1);
      shade_2 && self.setRemoveText(context, shade_2);
      $('.spp_mg_filter_list_1', context).addClass('dw__filter-by');
      $('.spp_mg_filter_list_2', context).addClass('dw__filter-by');
      if (self.isMobile()) {
        $('.spp_mg_filter_list_1', context).addClass('dw__shade-list');
        $('.spp_mg_filter_list_1 li:first-child', context).addClass('dw__shade-filter');
        $('.spp_mg_filter_list_2', context).addClass('dw__undertone-list');
        $('.spp_mg_filter_list_2 li:first-child', context).addClass('dw__undertone-filter');
      }
      self.renderTemplate(container);
      self.validateShade(context);
      $(document).on('dwAddToCart.success', function (e, cartResult) {
        if (typeof cartResult.getItem !== 'function') {
          return null;
        }
        // update cart count
        var item_count = cartResult.getCount();

        $('.page-utilities__cart-count').html(item_count);

        // don't show cart dropdown if flag is set
        if (typeof cartResult.updateCountOnly !== 'undefined') {
          return null;
        }
        var dw_foundation_sampling_kits = '';
        var allItems = cartResult.getAllItems();
        if (typeof cartResult.getAllItems !== 'undefined') {
          allItems.forEach(function (item) {
            dw_foundation_sampling_kits = typeof item !== 'undefined' ? item : '';
            if (
              typeof dw_foundation_sampling_kits !== 'undefined' &&
              dw_foundation_sampling_kits.isKitItem === 1 &&
              dw_foundation_sampling_kits.isDrammingItem === 1
            ) {
              cartResult.getItem().product.formattedAppliedPrice =
                dw_foundation_sampling_kits.formattedAppliedPrice;
              return 1;
            }
          });
        }

        self.launch(context, cartResult.getItem());
      });
      $(document).on('dwaddToCart.failure', function (e, cartMessage) {
        var overlayContent = '';

        cartMessage.forEach(function (cartMessage) {
          overlayContent = overlayContent.concat(cartMessage.text + '<br>');
        });
        generic.overlay.launch({
          content: overlayContent,
          includeBackground: true,
          cssStyle: {
            width: '540px',
            height: '200px'
          }
        });
      });

      $('.js-sppmg__hovShop', context).click(function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        self.selectShade(this, context, container);
      });
      $(document, context).on('click', '.js-sppmg__carousel', function (e) {
        var carouselContainer =
          $(e.target).is('.sppmg__carouselContainer') ||
          $(e.target).parents().is('.sppmg__carouselContainer');

        if (!carouselContainer) {
          self.closeModal(context);
        }
      });

      $(document, context).on(
        'click',
        '.dw__foundation__sampling__shades-selected .add-to-bag',
        function (e) {
          e.preventDefault();
          var add_to_cart = $(this);

          if (!$(add_to_cart).hasClass('button--disabled')) {
            $(add_to_cart)
              .after('<span class="dw-fs-loader dw-fs-btn-loader"></span>')
              .addClass('hidden');
            var sku_ids = [shades['shade_1']['sku-base-id'], shades['shade_2']['sku-base-id']];

            self.addSetToBag(context, sku_ids);
          }
        }
      );

      $('.js-dw-select-shade', context).on('click', function (e) {
        e.preventDefault();
        self.selectShade(this, context, container);
      });

      $(document, context).on('click', '.js-dw__foundation__sampling__remove__shade', function () {
        var shade = $(this).data('shade');

        self.removeShade(context, shade, container);
      });

      $(document, context).on('click', '.js-sppmg__hovRemove', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var sku_id = $(this).data('sku-base-id');
        var shade =
          self.getMapKeyValue(shades['shade_1'], 'sku-base-id') === sku_id ? 'shade_1' : 'shade_2';

        self.closeModal(context);
        self.removeShade(context, shade, container);
      });
    },
    renderTemplate: function (container) {
      var rendered = Mustache.render(container, shades);

      $('.js-dw__foundation__sampling__shades-selected').html(rendered).removeClass('hidden');
    },
    removeShade: function (context, shade, container) {
      var self = this;
      var split_shade = shade.split('_');
      var shadeSkuId = self.getShadeSkuId(shade);

      update_shade = split_shade[1] === '1' ? 1 : 2;
      shades.update_shade = update_shade;
      $('.js-sppmg__' + shadeSkuId, context).empty();
      $('.js-sppmg__hovShop__' + shadeSkuId, context).removeClass('hidden');
      delete shades[shade];
      this.setShades('dw_foundation_sampling_shades', shades);
      this.renderTemplate(container);
      self.validateShade(context);
    },
    setShades: function (key, value) {
      localStorage.setItem(key, JSON.stringify(value));
    },
    getMapKeyValue: function (obj, key) {
      var self = this;

      if (!self.isEmpty(obj)) {
        if (obj.hasOwnProperty(key)) {
          return obj[key];
        }
      }

      return 0;
    },
    isEmpty: function (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false;
        }
      }

      return true;
    },
    validateShade: function (context) {
      var self = this;
      var add_to_cart = $('.dw__foundation__sampling__shades-selected .add-to-bag', context);
      var shade_1 = self.getMapKeyValue(shades['shade_1'], 'sku-base-id');
      var shade_2 = self.getMapKeyValue(shades['shade_2'], 'sku-base-id');

      if (!shade_1 || !shade_2) {
        $(add_to_cart).addClass('button--disabled');
      }
    },
    closeModal: function (context) {
      $('.js-sppmg__modalBg', context).fadeOut();
      $('.js-sppmg__carousel', context).fadeOut();
    },
    addShade: function (context, container, shade_object) {
      var self = this;

      update_shade = shades.update_shade === 1 ? 2 : 1;
      shades.update_shade = update_shade;
      shade_object = Object.assign(shades, shade_object);
      !shade_object.alias && (shade_object.alias = window.location.pathname);
      self.setShades('dw_foundation_sampling_shades', shade_object);
      self.renderTemplate(container);
      self.validateShade(context);
      self.closeModal(context);
      $('html, body').animate(
        {
          scrollTop: $('#js-dw__foundation__sampling__shades', context).offset().top - 150
        },
        'slow'
      );
    },
    selectShade: function (self, context, container) {
      var inner_self = this;
      var sku_id = $(self, context).data('sku-base-id');
      var sppmg_image_path = $(self, context).data('sppmg-src');
      var sppmg_hoveyebrow = $(self, context).data('sppmg-hoveyebrow');
      var sppmg_copy = $(self, context).data('sppmg-copy');
      var key = 'shade_' + update_shade;
      var shade_object = {};
      var shade_exist = 0;

      if (Object.keys(shades).length <= 1) {
        key = 'shade_1';
        shades.update_shade = 1;
      }
      var shadeSkuId = inner_self.getShadeSkuId(key);

      Object.keys(shades).forEach(function (key) {
        if (shades[key]['title'] === sppmg_hoveyebrow) {
          if (!$(self, context).hasClass('js-sppmg__hovShop')) {
            inner_self.closeModal(context);
          }
          shade_exist = 1;
        }
      });
      if (!shade_exist) {
        $('.js-sppmg__' + shadeSkuId, context).empty();
        $('.js-sppmg__hovShop__' + shadeSkuId, context).removeClass('hidden');
        this.setRemoveText(context, sku_id);
        shade_object[key] = {
          title: sppmg_hoveyebrow,
          desc: sppmg_copy,
          'sku-base-id': sku_id,
          img_path: sppmg_image_path
        };
        this.addShade(context, container, shade_object);
      }
    },
    addSetToBag: function (context, sku_ids) {
      var collection_type = $(
        '.dw__foundation__sampling__shades-selected__btn-container',
        context
      ).data('col-type');
      var cat_base_id = $(
        '.dw__foundation__sampling__shades-selected__btn-container',
        context
      ).data('cat-base-id');
      var collection_subtype = $(
        '.dw__foundation__sampling__shades-selected__btn-container',
        context
      ).data('col-subtype');
      var collection_name = $(
        '.dw__foundation__sampling__shades-selected__btn-container',
        context
      ).data('col-name');
      var add_to_cart = $('.dw__foundation__sampling__shades-selected .add-to-bag', context);
      var paramObj = {
        INCREMENT: 1,
        COLLECTION_TYPE: collection_type,
        CAT_BASE_ID: cat_base_id,
        COLLECTION_SUBTYPE: collection_subtype,
        COLLECTION_NAME: collection_name + Math.floor(Math.random() * 10000),
        SKU_BASE_ID: sku_ids,
        QTY: 1,
        action: 'add,edit,create_kit',
        _SUBMIT: 'alter_collection',
        HAS_MULTIPLE_SKUS: 1
      };

      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: [paramObj],
        onSuccess: function (r) {
          var resultObj = r.getCartResults();

          $('.dw-fs-loader', context).remove();
          $(add_to_cart).removeClass('hidden');
          var itemsObj = r.getData();
          if (
            itemsObj.trans_data &&
            itemsObj.trans_data.order &&
            Array.isArray(itemsObj.trans_data.order.kits)
          ) {
            trnsItems = itemsObj.trans_data.order.kits[0].items;
          }
          $(document).trigger('dwAddToCart.success', [resultObj]);
        },
        onFailure: function (r) {
          var errorObjectsArray = r.getMessages();

          $('.dw-fs-loader', context).remove();
          $(add_to_cart).removeClass('hidden');
          $(document).trigger('dwaddToCart.failure', [errorObjectsArray]);
        }
      });
    },
    removeShadeStorage: function (key) {
      localStorage.removeItem(key);
    },
    launch: function (context, resultObj) {
      var content = $('script.inline-template[path="cart_confirm"]', context).html();
      var cartSKUItems = resultObj.product.sku;

      trnsItems.forEach(function (trnsItem) {
        if (
          trnsItem['sku.SKU_BASE_ID'] !== cartSKUItems['SKU_BASE_ID'] &&
          trnsItem['sku.SHADENAME'] !== ''
        ) {
          Object.assign(resultObj['product']['sku'], {
            FOUNDATION_SHADE: {
              HEX_VALUE_STRING: trnsItem['sku.HEX_VALUE_STRING'],
              HEX_VALUE_1: trnsItem['sku.HEX_VALUE_STRING'],
              SHADENAME: trnsItem['sku.SHADENAME']
            }
          });
        } else if (
          trnsItem['sku.SKU_BASE_ID'] === cartSKUItems['SKU_BASE_ID'] &&
          trnsItem['sku.SHADENAME'] === cartSKUItems['SHADENAME']
        ) {
          resultObj.product.sku.HEX_VALUE_1 = trnsItem['sku.HEX_VALUE_STRING'];
          resultObj.product.sku.XXS_IMAGE = trnsItem['sku.SMALL_IMAGE'];
        }
      });

      var html = Mustache.render(content, resultObj);

      $('.cart-confirm__content', context).html(html).parent().fadeIn('200');
      setTimeout(function () {
        $('.cart-confirm__content', context).parent().fadeOut('200');
      }, 3500);
    },
    getShadeSkuId: function (shade) {
      return this.getMapKeyValue(shades[shade], 'sku-base-id');
    },
    setRemoveText: function (context, sku_id) {
      var removeText = $(
        '.dw__foundation__sampling__shades-selected__shades__container',
        context
      ).data('shade-remove');

      $('.js-sppmg__' + sku_id, context).html(removeText);
      $('.js-sppmg__hovShop__' + sku_id, context).addClass('hidden');
    },
    isMobile: function () {
      return +$.cookie('client.isMobile') || 0;
    }
  };
})(jQuery);
